module.exports = __webpack_public_path__ + "static/img/111.57da1ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/111.png
// module id = 801i
// module chunks = 0